import classnames from 'classnames';
import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import TrashsIcon from '@krea/common/images/svg/trash.svg';
import Button from '@krea/common/shared-components/button';
import FileSection from '@krea/common/shared-components/fields/file-section';
import FileSectionAction from '@krea/common/shared-components/fields/file-section/FileSectionAction';
import TextInput from '@krea/common/shared-components/fields/input';
import { Label } from '@krea/common/shared-components/fields/label';
import { Text } from '@krea/common/shared-components/text';
import {
  useDelegateFieldRequest,
  useWithdrawDelegationFieldRequest,
} from '@krea/common/store/field-requests/hooks/mutations';
import { useGetOneFieldRequest } from '@krea/common/store/field-requests/hooks/queries';
import { isValidEmail } from '@krea/common/utils';

const FieldRequestDelegateForm = ({ fieldRequestID }) => {
  const { t } = useTranslation();
  const [delegatedEmail, setDelegatedEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  const { data: request = {} } = useGetOneFieldRequest(fieldRequestID);
  const { mutate: delegateFieldRequest } = useDelegateFieldRequest();
  const { mutate: withdrawDelegationForFieldRequest } =
    useWithdrawDelegationFieldRequest();

  const onDelegateFieldRequest = () => {
    if (!isValidEmail(delegatedEmail)) {
      setEmailError(t('delegateFieldRequest.validation.invalidEmail'));

      return;
    }

    delegateFieldRequest({
      fieldRequestID: request?.id,
      email: delegatedEmail,
    });
    setDelegatedEmail('');
  };

  const onWithdrawDelegationForFieldRequest = (email) => {
    withdrawDelegationForFieldRequest({ fieldRequestID: request?.id, email });
  };

  useEffect(() => {
    setEmailError('');
  }, [delegatedEmail]);

  return (
    <Fragment>
      {request.delegatedInformationResources &&
        request.delegatedInformationResources.length > 0 && (
          <div className="pb-4 mb-6 border-bottom">
            <Label className="mb-2">
              {t('delegateFieldRequest.personsWithAccessTitle')}
            </Label>

            {request.delegatedInformationResources.map((delegate, i) => (
              <FileSection
                key={i}
                variant="user"
                className={classnames({
                  'mb-3':
                    request.delegatedInformationResources.length !== i + 1,
                })}
                title={delegate.delegatedEmail}
                actions={
                  <FileSectionAction
                    title={t('delegateFieldRequest.revokeAccess')}
                    icon={TrashsIcon}
                    onClick={() =>
                      onWithdrawDelegationForFieldRequest(
                        delegate.delegatedEmail,
                      )
                    }
                  />
                }
              />
            ))}
          </div>
        )}

      <div className="pb-4">
        <Text size="md" className="font-weight-bold mb-4">
          {t('delegateFieldRequest.inviteHeading')}
        </Text>

        <TextInput
          type="email"
          id="garantors-edit-email"
          value={delegatedEmail}
          onChange={({ target }) => setDelegatedEmail(target.value)}
          placeholder={t('iaq.guarantor.emailPlaceholder')}
          label={t('applicationForm.commons.emailLabel')}
          error={emailError}
        />

        <div className="d-flex justify-content-end pt-5">
          <Button
            variant={!delegatedEmail ? 'contained' : 'outlined'}
            size="sm"
            onClick={onDelegateFieldRequest}
            id="modal-cancel-button"
            disabled={!delegatedEmail}
          >
            {t('delegateFieldRequest.ctaButton')}
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

export default FieldRequestDelegateForm;
